import CountryPageRenderer from '../components/CountryPageRenderer';
import japanData from '../data/country-pages/japan';

export default function JapanCountryPage() {
  return <CountryPageRenderer data={japanData} />;
}
